export default function PricingCtaBar({ onSubscribe }) {
  return (
    <section className="px-4 py-10 sm:px-6 lg:px-8">
      <div className="w-full bg-gradient-to-b from-[#FFFFFF] to-[#DCF0FF] py-8 shadow-[0_8px_40px_rgba(0,0,0,0.12)] sm:py-10">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-stretch gap-4 rounded-2xl bg-gradient-to-r from-[#D2E0FE] to-[#DBD0FD] px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-16">
          <p className="flex flex-col items-center gap-3 text-center text-base font-bold text-[#1B1B1B] sm:flex-row sm:text-left sm:text-lg">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#9369CC]/15 text-[#9369CC]">
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            </span>
            Unlock Full CHSE Syllabus Access @ 99
          </p>

          <button
            type="button"
            onClick={onSubscribe}
            className="shrink-0 self-center rounded-xl bg-gradient-to-t from-[#6A74E1] to-[#B539FD] px-8 py-3 text-base font-semibold text-white shadow-md transition hover:opacity-90 sm:self-auto"
          >
            Subscribe Now
          </button>
        </div>
      </div>
    </section>
  );
}
